export default "__VITE_ASSET__6cff9e80__"